import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import GlobalStyle from 'styles/GlobalStyle';
import theme from 'styles/themes';
import { QueryClientProvider } from 'react-query';
import queryCache from 'data/cache';
import { SnackbarProvider } from 'notistack';
import notistackConfig from 'utils/Snackbar/config';
import 'utils/Snackbar/base-styles.css';
import ScrollToTop from 'utils/ScrollToTop';
import { Segment } from 'utils/segment';
import {
  FirebaseDatabaseContext,
  FirebaseAuthContext,
  firebaseAuth,
  firebaseDatabase,
} from 'data/firebase';

import Auth from './Auth';

const App = () => {
  return (
    <QueryClientProvider client={queryCache}>
      <ThemeProvider theme={theme}>
        <FirebaseAuthContext.Provider value={firebaseAuth}>
          <FirebaseDatabaseContext.Provider value={firebaseDatabase}>
            {/* @ts-ignore */}
            <SnackbarProvider {...notistackConfig}>
              <BrowserRouter>
                <ScrollToTop />
                <Segment />
                <GlobalStyle />
                <Auth />
              </BrowserRouter>
            </SnackbarProvider>
          </FirebaseDatabaseContext.Provider>
        </FirebaseAuthContext.Provider>
      </ThemeProvider>
    </QueryClientProvider>
  );
};

export default App;
